/**
 * Calculate maximum solar capacity based on area and installation type
 * 
 * @param {number} area - Available area in square feet
 * @param {string} type - Installation type ('flat', 'tilted', 'carport', 'ground')
 * @param {number} wattsPerSqFt - Watts per square foot (default: 15)
 * @returns {string} - Maximum capacity in kW, formatted to 2 decimal places
 */
export const calculateSolarCapacity = (area, type, wattsPerSqFt = 20) => {
  if (!area || area <= 0) return "0.00";
  
  // Surface utilization factors based on installation type
  const utilizationFactors = {
    'flat': 0.75,
    'tilted': 0.85,
    'carport': 0.75,
    'ground': 0.90
  };
  
  // Default to flat if type is not recognized
  const utilizationFactor = utilizationFactors[type] || 0.75;
  
  // Calculate capacity in kW
  return ((area * utilizationFactor * wattsPerSqFt) / 1000).toFixed(2);
}; 